import { OsmAPIList } from '@/api'

const api = new OsmAPIList();

export default {
  getRenewalList({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getRenewalList(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  getQuickRenewalList({ state, commit }, params) {
    var obj = {
      ...params,
      recentRecord: 1
    }
    return new Promise((resolve, reject) => {
      api.getRenewalList(obj, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  renewLife({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.renewLifePolicy(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

}



// WEBPACK FOOTER //
// ./src/Osm/Renewal/store/actions.js